<template>
  <div class="invitation-page" @touchstart.stop @touchmove.stop @touchend.stop>
    <img
      class="logo"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/dc992b0bd30e6f732f07c5d64dcec1fc_wh=1340_124.webp"
      alt=""
    />
    <slider ref="slider" :options="options" @slide="slide">
      <slideritem>
        <div class="content-item">
          <img
            class="image-item"
            src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/b04af85fa2d1d65dbabd41fb25b2d194_wh=1500_2640.webp"
            alt=""
          />
          <div class="c-btn">
            <img
              class="c-icon"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/77009cc22cc54faf650b7878f04b492a_wh=72_76.webp"
              alt=""
            />
            <div>邀请你奔赴更好的自己</div>
          </div>
        </div>
      </slideritem>
      <slideritem>
        <div class="content-item">
          <img
            class="image-item"
            src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/22df5465dc8f4938f8789982c10a1e29_wh=1500_2640.webp"
            alt=""
          />
          <div class="c-btn">
            <img
              class="c-icon"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/77009cc22cc54faf650b7878f04b492a_wh=72_76.webp"
              alt=""
            />
            <div>上划了解健康空间</div>
          </div>
        </div>
      </slideritem>
      <slideritem>
        <div class="content-item">
          <img
            class="image-item"
            src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/38d2b8e5f384045f48dcdc335d6d0f54_wh=1500_2640.webp"
            alt=""
          />
          <div class="c-btn">
            <img
              class="c-icon"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/77009cc22cc54faf650b7878f04b492a_wh=72_76.webp"
              alt=""
            />
            <div>上划定制专属训练计划</div>
          </div>
        </div>
      </slideritem>
      <slideritem>
        <div class="question-container">
          <QuestionData ref="question" @submit="bindNext" />
        </div>
      </slideritem>
      <slideritem>
        <div class="content-item">
          <img
            class="image-item"
            src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/a2ed1aef972167931c6beb734f3c4d8a_wh=1500_2640.webp"
            alt=""
          />
        </div>
      </slideritem>
    </slider>
  </div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider' // 引入slider组件
import QuestionData from './question-data.vue'
import BetterweWxApi from '@/components/wx/control.js'
export default {
  components: {
    slider,
    slideritem,
    QuestionData
  },
  data() {
    return {
      options: {
        pagination: false,
        direction: 'vertical',
        currentPage: 0,
        effect: 'nest',
        thresholdDistance: 50
      },
      shareOptions: {
        title: '健萌健身北京概念店邀请函',
        desc: '静候相逢，共赴蜕变之旅',
        imgUrl:
          'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-05/212098729245e786b54add54ad43b73c_wh=1500_1500.png'
      }
    }
  },
  created() {
    this.setShareOptions()
  },
  methods: {
    // 轮播图切换监听事件
    slide(data) {
      this.curPage = data.currentPage
      console.log(data)
      if (
        data.currentPage == 4 &&
        data.direction == 'down' &&
        !this.$refs.question.checkQuestion()
      ) {
        this.$toast('你还没填完问卷哦')
        this.$refs.slider.$emit('slidePre')
      }
    },
    bindNext() {
      this.$refs.slider.$emit('slideNext')
    },
    setShareOptions() {
      let shareOptions = Object.assign({}, this.shareOptions)
      shareOptions.link = location.href
      BetterweWxApi.setShareData(shareOptions, shareOptions)
    }
  }
}
</script>
<style lang="scss" scoped>
.invitation-page {
  background: rgb(255, 6, 71);
  width: 100%;
  height: 100vh;
  position: relative;

  .logo {
    position: absolute;
    width: 335px;
    height: 31px;
    left: 50%;
    top: 20px;
    transform: translate(-50%, 0%);
  }

  .content-item {
    width: 100%;
    height: 100vh;

    .image-item {
      width: 100%;
      height: 660px;
    }
  }

  .question-container {
    color: rgba(0, 0, 0, 0.8);
    width: 100%;
    height: 100vh;
  }
}

.c-btn {
  margin: 10px auto;
  position: relative;
  width: 335px;
  box-sizing: border-box;
  padding-left: 100px;
  height: 44px;
  border-radius: 19px;
  border-top: 1px solid rgba(255, 255, 255, 0.8);
  border-left: 1px solid rgba(255, 255, 255, 0.7);
  border-right: 1px solid rgba(255, 255, 255, 0.7);
  font-size: 16px;
  color: #ffffff;
  display: flex;
  align-items: center;

  .c-icon {
    position: absolute;
    left: 75px;
    top: 50%;
    transform: translate(0%, -50%);
    width: 18px;
    height: 19px;
  }
}
</style>
